(function () {
  var bar = document.querySelector('[data-pbar]');
  var form = document.querySelector('[data-product-form]');
  if (!bar || !form) return;
  var btn = form.querySelector('[data-add-btn]');
  bar.querySelector('[data-pbar-btn]').addEventListener('click', function () {
    if (btn && !btn.disabled) { btn.click(); } else { form.scrollIntoView({ behavior: 'smooth' }); }
  });
  if ('IntersectionObserver' in window && btn) {
    new IntersectionObserver(function (e) {
      bar.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }).observe(btn);
  }
  var price = form.querySelector('[data-variants]') ? document.querySelector('[data-price]') : null;
  var target = bar.querySelector('[data-pbar-price]');
  if (price && target && 'MutationObserver' in window) {
    new MutationObserver(function () { target.textContent = price.textContent; }).observe(price, { childList: true, characterData: true, subtree: true });
  }
})();
